/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PendingArticleResponsePage } from '../../models/pending-article-response-page';

export interface ListPendingArticles$Params {
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'link' | '-link' | 'userId' | '-userId' | 'articleId' | '-articleId'>;
}

export function listPendingArticles(http: HttpClient, rootUrl: string, params?: ListPendingArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<PendingArticleResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listPendingArticles.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {"style":"form"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PendingArticleResponsePage>;
    })
  );
}

listPendingArticles.PATH = '/v0/pending-articles';
